import { useRef, useState } from "react";
import { api } from "@/lib/api";
import { ImagePlus, FileText, Music, Loader2 } from "lucide-react";

export default function Uploader({
  onUploaded,
  accept = "image/*,video/*,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,text/plain,application/x-ipynb+json,.ipynb,.docx,.doc,.pdf,.txt,.md,.gdoc",
  label = "Add photo, video, or notebook",
  testId = "uploader",
  icon = "image",
}) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", f);
      const { data } = await api.post("/files/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded?.(data);
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  const Icon = icon === "doc" ? FileText : icon === "music" ? Music : ImagePlus;

  return (
    <>
      <button type="button" onClick={() => ref.current?.click()} disabled={busy}
        className="btn-secondary !py-2 !px-4 text-sm flex items-center gap-2" data-testid={testId}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Icon className="h-4 w-4" strokeWidth={1.5} />}
        {busy ? "Uploading…" : label}
      </button>
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={handle} data-testid={`${testId}-input`} />
    </>
  );
}
